import { CustomComponentProps } from "@repo/dynamicEditor/src/dynamicComponent/types";

import { Score } from "./fieldAudits";
import { componentType } from "./portalDynamicComponent";
import { FullProps, SpecificProps } from "./types";

/** Dynamic Components specific to Telemarketing application */
function PortalComponents(props: FullProps) {
	const { component } = props;

	switch (component.type as componentType) {
		case componentType.score:
			return <Score id={component.component.propertyName} repFieldAudit={props.repFieldAudit} />;
		default:
			return null;
	}
}

export const getPortalComponents = (props: SpecificProps) => (componentProps: CustomComponentProps) => {
	return PortalComponents({ ...props, ...componentProps });
};
